<template>
  <el-container>
    <!-- 头部导航栏 -->
    <el-header style='height: 70px' :class="{fixed: navBarFixed}">
      <div class='head'>
        <div class='index' @click='index1'>
          <div class='avatar_box'><img src='../assets/logo.jpg' /></div>
          <span>一个正经的非正式网站</span>
        </div>
        <div class='header'>
          <el-link
            :underline='false'
            @click='getHome'
            target='_blank'
            >首页</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >地方特色</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >产品大全</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >商务合作</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >关于我们</el-link
          >
          <el-link @click='navigat' :underline='false' target='_blank'>导航</el-link>
          <div class='logout'>
            <el-link @click='admin' :underline='false' v-show='showadmin'>
              管理员
            </el-link>
            <el-link @click='logout' :underline='false'> 退出登录 </el-link>
          </div>
        </div>
      </div>
    </el-header>

    <!-- 主体区 -->
    <el-main>
      <!-- 轮播图 -->
      <div class='block'>
        <el-carousel :height="bannerHeight + 'px'">
          <el-carousel-item v-for='(item, index) in imgList' :key='index'>
            <img
              :src="item.url"
              alt=''
              style='min-width: 100%; min-height: 100%'
            />
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 新闻 -->
      <div class='new'>
        <div class='news'>
          <h1>综合新闻</h1>
          <el-row :gutter='20'>
            <el-col :span='11' :key='item.id' v-for='(item, index) in newlist'>
              <div class='grid-content' v-if='index < 4'>
                <h3>{{ item.theme }}</h3>
                <a @click='getnew(item.id)'>
                  <div class='newcontent'>{{ item.text }}</div>
                </a>
                <div class='box1'>{{ item.releaseTime }}</div>
              </div>
            </el-col>
          </el-row>
          <a @click='getmore'>
            <el-button class='botn1' plain>查看更多</el-button></a
          >
        </div>

        <div class='notices'>
          <h1>公告通知</h1>
          <el-row :key='item.id' v-for='(item, index) in noticelist'>
            <el-col>
              <div class='grid-content2' v-if='index < 4'>
                <a @click='getnotice(item.id)'> {{ item.theme }}</a>
                <div class='box2'>{{ item.createDate }}</div>
              </div>
            </el-col>
          </el-row>
          <a @click='getmore2'>
            <el-button class='botn2' plain>查看更多</el-button></a
          >
        </div>
      </div>
      <!-- 网站 -->
      <div class='web'>
        <h1>专题网站</h1>
        <div class='card'>
          <el-row :gutter='40'>
            <el-col :span='6'>
              <a @click='blankTip' target='_blank'>
                <div class='grid-content w1'>
                  <div class='title'>读史明鉴</div>
                  <div class='more'>查看更多</div>
                  <div class='wire'></div>
                </div>
              </a>
            </el-col>
            <el-col :span='6'>
              <a
                @click='blankTip'
                target='_blank'
              >
                <div class='grid-content w3'>
                  <div class='title'>求知创新</div>
                  <div class='more'>查看更多</div>
                  <div class='wire'></div>
                </div>
              </a>
            </el-col>
            <el-col :span='6'>
              <a
                @click='blankTip'
                target='_blank'
                ><div class='grid-content w4'>
                  <div class='title'>诸子百家</div>
                  <div class='more'>查看更多</div>
                  <div class='wire'></div>
                </div>
              </a>
            </el-col>
            <el-col :span='6'>
              <a href='http://dangshi.people.com.cn/' target='_blank'>
                <div class='grid-content w2'>
                  <div class='title'>党史专题</div>
                  <div class='more'>查看更多</div>
                  <div class='wire'></div>
                </div>
              </a>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 风景 -->
      <div class='show'>
        <h1>作 品 鉴 赏</h1>

        <div class='lunbo'>
          <div class='block'>
            <el-carousel height='500px'>
              <el-carousel-item v-for='(item, index) in imgList2' :key='index'>
                <img :src="item.url" style='max-width: 100%' />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div v-for='(item, index) in imgList3' :key='index' :class='pic[index]'>
          <img :src="item.url" />
        </div>
        <!-- <div class='p1'><img src='../assets/p1.jpg'/></div>
          <div class='p2'><img src='../assets/p2.jpg' /></div>
          <div class='p3'><img src='../assets/p3.jpg' /></div>
          <div class='p4'><img src='../assets/p4.jpg' /></div -->
      </div>

      <!-- 底部 -->
      <el-footer height='300px'>
        <div class='icon'>
          <a href='https://www.114369.cn/ci73b/jianjie.html' target='blank'>
            <div class='icons'>
              <img src='../assets/two_icon2.jpg' alt='官网' />
              <h1>官网</h1>
            </div>
          </a>
          <a target='blank' @click="drawer = true">
            <div class='icons'>
              <img src='../assets/two_icon5.jpg' alt='联系我们' />
              <h1>联系我们</h1>
            </div>
          </a>
          <a href='http://wlt.hubei.gov.cn/bmdt/ztzl/zshb/201911/t20191121_1363618.shtml' target='blank'>
            <div class='icons'>
              <img src='../assets/two_icon6.jpg' alt='档案' />
              <h1>档案</h1>
            </div>
          </a>
          <a href='http://xsxlib.org.cn:8081/info/70984.jspx' target='blank'>
            <div class='icons'>
              <img src='../assets/foot_icon1.jpg' alt='图书馆' />
              <h1>图书馆</h1>
            </div>
          </a>
        </div>
      </el-footer>
      <div class='footcontent'>
        地址：湖北省武汉市洪山区关山大道888号 438200 版权所有
        一个正经的非正式网站 鄂ICP备2021021940号 <br />
        咨询：0713-88888888 87713758 87713759
        传真：0713-87583759 监督电话：0713-87713651
      </div>

      <!-- <el-dialog title="提示"
        :visible.sync="tipsVisible"
        width="30%"
        :modal-append-to-body="false"
        @close="close()">
        <h3>相关功能正在建设中，请移步他处</h3>
        <h1>{{ seconds }}</h1>
      </el-dialog> -->
      <!-- 侧边弹窗 -->
      <el-drawer
        title="留言"
        size="20%"
        :visible.sync="drawer"
        :before-close="handleClose"
        class="drawer">
        <span class="drawer-title">您的意见对我们很重要!</span>
        <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入您的意见"
            v-model="comments"
            maxlength="300"
            style="width: 75%"
          >
        </el-input>
        <!-- 底部 -->
        <span class="drawer-footer">
          <el-button type="primary" @click="submit()"> 确 定 </el-button>
          <el-button @click="handleClose()">取消</el-button>
        </span>
      </el-drawer>
    </el-main>
  </el-container>
</template>

<script>
export default {
  inject: ['reload'],
  data () {
    return {
      pic: ['p1', 'p2', 'p3', 'p4'],
      // 轮播图地址列表
      imgList: {
        id: '',
        name: ''
      },
      imgList2: {
        id: '',
        name: ''
      },
      imgList3: {
        id: '',
        name: ''
      },
      navBarFixed: false,
      // 定义窗口高度
      bannerHeight: document.body.clientHeight,

      // 获取新闻列表参数对象
      newlist: {
        id: '',
        theme: '',
        text: '',
        releaseTime: ''
      },
      noticelist: {
        id: '',
        theme: '',
        message: '',
        createDate: ''
      },
      showadmin: false,
      drawer: false,
      comments: ''
    }
  },
  // 生命周期函数，页面一打开就能获取新闻列表
  created () {
    // 获取新闻列表
    this.getNewList()
    this.getNoticeList()
    this.getPictureList()
    this.getPictureList2()
    this.getPictureList3()
    // 获取是否管理员登录
    this.getShowadmin()
  },

  mounted () {
    // 监测鼠标滚动函数
    window.addEventListener('scroll', this.watchScroll)
    // 轮播图监听
    this.imgLoad()
    window.addEventListener(
      'resize',
      () => {
        if (this.$refs.bannerHeight[0] !== undefined) {
          this.bannerHeight = this.$refs.bannerHeight[0].height
        }
        this.imgLoad()
      },
      false
    )

    // 获取窗口高度
    const that = this
    window.onresize = () => {
      return () => {
        window.bannerHeight = document.body.clientHeight
        that.bannerHeight = window.bannerHeight
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.imgLoad, false)
  },

  // 监听窗口高度改变
  watch: {
    bannerHeight (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的高度值改变，就将其重新赋给data里的高度
        this.bannerHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印窗口高度变化的值
          console.log(that.bannerHeight)
          that.timer = false
        }, 400)
      }
    }
  },

  methods: {
    async getShowadmin () {
      // 转换为布尔值
      const showAdmin = window.sessionStorage.getItem('showAdmin')
      console.info('================showAdmin : ' + showAdmin)
      if (showAdmin !== null && showAdmin === 'true') {
        this.showadmin = true
      }
      console.info('================showadmin : ' + this.showadmin)
    },
    async getPictureList () {
      const { data: res } = await this.$http.post('/picture/selectList', {type: 1})
      if (res.code !== 1) {
        return this.$message.error('获取图片列表失败！')
      }
      this.imgList = res.body
    },
    async getPictureList2 () {
      const { data: res } = await this.$http.post('/picture/selectList', {type: 2})
      if (res.code !== 1) {
        return this.$message.error('获取图片列表失败！')
      }
      this.imgList2 = res.body
    },
    async getPictureList3 () {
      const { data: res } = await this.$http.post('/picture/selectList', {type: 3})
      if (res.code !== 1) {
        return this.$message.error('获取图片列表失败！')
      }
      this.imgList3 = res.body
    },
    // 退出登录
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 跳转首页
    index1 () {
      this.$router.push('/home')
    },
    // 跳转管理员页面
    admin () {
      this.$router.push('/admin')
    },
    // 跳转导航页面
    navigat () {
      this.$router.push('/navigation')
    },
    // 跳转新闻页面
    async getnew (id) {
      this.$router.push({ path: '/news', query: { setid: id } })
    },
    async getnotice (id) {
      this.$router.push({ path: '/news2', query: { setid: id } })
    },
    // 查看更多
    getmore () {
      this.$router.push('/more')
    },
    getmore2 () {
      this.$router.push('/more2')
    },

    // 监测鼠标滚动后使导航栏吸顶
    watchScroll () {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // console.log(scrollTop);
      if (scrollTop > 1) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },

    // 轮播图自适应高度监听
    imgLoad () {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height
      })
    },

    // 获取新闻事件
    async getNewList () {
      const { data: res } = await this.$http.post('/news/selectList', {'body': {}})
      if (res.code !== 1) return this.$message.error('获取新闻失败')
      this.newlist = res.body.data
      console.log(res.body)
    },
    // 获取通知
    async getNoticeList () {
      const { data: res } = await this.$http.post('/notices/selectList', {'body': {}})
      if (res.code !== 1) return this.$message.error('获取通知失败')
      this.noticelist = res.body.data
      console.log(res.body)
    },
    getHome () {
      // 转换为布尔值
      const token = window.sessionStorage.getItem('token')
      if (token !== null) {
        this.$router.push('/home')
      } else {
        this.$router.push('/login')
      }
    },
    blankTip () {
      // 转换为布尔值
      this.$message.info('相关功能正在建设中，请移步他处,感谢您的支持与理解！')
    },
    async submit () {
      const { data: res } = await this.$http.post('/comments/addComments', {leaveComments: this.comments})
      if (res.code !== 1) return this.$message.error('提交异常，请稍后重试！')
      this.noticelist = res.body
      this.comments = ''
      this.drawer = false
      this.$message.success('感谢你的宝贵意见！')
    },
    handleClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.comments = ''
          this.drawer = false
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang='less' scoped>
.el-header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  background: linear-gradient(45deg, #0081ff, #1cbbb4);
  font-weight: 900;
  font-size: 20px;
  color: rgb(255, 255, 255);
  .head,
  .index {
    display: flex;
    justify-content: center;
    align-items: center;
    .avatar_box {
      height: 60px;
      width: 60px;
      margin: 7.5px 10px 7.5px 10px;
      min-width: 60px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .header {
      margin-left: 260px;
      .logout {
        display: inline-block;
        margin-left: 200px;
        .el-link {
          margin: 10px;
        }
      }
    }
    span {
      width: 210px;
    }
    .index {
      cursor: pointer;
    }
  }
}
.el-link {
  color: white !important;
  margin: auto 30px;
  font-size: 16px !important;
  :hover {
    color: rgb(0, 204, 255);
  }
}
.el-row {
  margin-bottom: 48px;
  &:last-child {
    margin-bottom: 0;
  }
}

.new {
  position: relative;
  height: 700px;
  background: #ffffff;
  padding: 40px 160px;
  margin: 0;
  h1 {
    font-size: 40px;
    margin-top: 15px;
    margin-bottom: 0px;
  }
  .grid-content {
    position: relative;
    padding: 20px;
    height: 195px;
    min-height: 36px;
    background: #fafafa;

    .newcontent {
      width: 100%;
      height: 130px;
      text-indent: 2em;
      line-height: 2em;
      display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      -webkit-line-clamp: 4; /*显示的行数；如果要设置2行加...则设置为2*/
      overflow: hidden; /*超出的文本隐藏*/
      text-overflow: ellipsis; /* 溢出用省略号*/
      -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      text-align: justify;
    }
    h3 {
      margin: 15px auto 10px auto;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
    .box1 {
      position: absolute;
      top: -20px;
      right: 10px;
      height: 30px;
      background: #3d2d8b;
      color: aliceblue;
      text-align: center;
      line-height: 30px;
      font-size: 6px;
      width: 80px;
    }
  }
  .news {
    .el-col {
      margin-top: 50px;
    }
  }
  .notices {
    h1 {
      margin-bottom: 50px;
    }
  }
  .news,
  .notices {
    width: 50%;
    float: left;
    box-sizing: border-box;
    height: 800px;
  }

  .grid-content2 {
    overflow: hidden;
    text-overflow: ellipsis; /* 溢出用省略号*/
    padding: 10px;
    padding-left: 25px;
    height: 72px;
    min-height: 36px;
    background: #fafafa;
    text-align: left;
    line-height: 72px;
    font-size: 20px;
    font-weight: 600;

    .box2 {
      position: absolute;
      top: -20px;
      right: 10px;
      height: 30px;
      background: #3d2d8b;
      color: aliceblue;
      text-align: center;
      line-height: 30px;
      font-size: 6px;
      font-weight: normal;
      width: 80px;
    }
  }
  .botn1 {
    border: 2px #3d2d8b solid !important;
    border-radius: 5px !important;
    height: 45px;
    width: 140px;
    position: absolute;
    bottom: 40px;
    left: 158px;
    color: #3d2d8b;
    padding: 0 !important;
  }
  .botn1:hover,
  .botn2:hover {
    background: #3d2d8b;
    color: #ffffff;
  }
  .botn2 {
    border: 2px #3d2d8b solid !important;
    border-radius: 5px !important;
    height: 45px;
    width: 140px;
    position: absolute;
    bottom: 40px;
    right: 158px;
    color: #3d2d8b;
    padding: 0 !important;
  }
}

.web {
  position: relative;
  height: 900px;
  background: #f5f5f5;
  h1 {
    float: left;
    margin: 75px 20px auto 160px;
    font-size: 40px;
    width: 40px;
  }
  .card {
    position: absolute;
    // bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    margin-top: 70px;
    width: 1200px;
    float: left;
    .grid-content {
      position: relative;
      transition: all 0.4s;
      border-top: 0px solid transparent;
      height: 710px;
      padding-left: 30px;
      padding-top: 30px;
      .title {
        width: 30px;
        font-size: 25px;
        font-weight: 320;
        color: #ffffff;
      }
      .more {
        position: absolute;
        bottom: 10px;
        left: 200px;
        width: 10px;
        font-weight: 400;
        color: #ffffff;
      }
      .wire {
        position: absolute;
        bottom: 100px;
        left: 207px;
        background: #ffffff;
        height: 58px;
        width: 0px;
        border: 1px solid rgb(255, 255, 255);
      }
    }

    .w1 {
      background: url('../assets/four_bg2.jpg') fixed;
    }
    .w2 {
      background: url('../assets/four_bg1.jpg') fixed;
    }
    .w3 {
      background: url('../assets/four_bg3.jpg') fixed;
    }
    .w4 {
      background: url('../assets/four_bg4.jpg') fixed;
    }
  }
  .grid-content:hover {
    border-top-width: 25px;
    // bottom: 10px;
  }
}
.show {
  position: relative;
  background: url(../assets/bg.jpg) no-repeat;
  background-size: cover;
  height: 760px;
  h1 {
    margin-top: 0;
    padding-top: 82px;
    text-align: center;
    font-size: 40px;
  }
  .lunbo {
    margin-left: 180px;
    float: left;
    width: 750px;
    height: 500px;
  }

  img {
    transition: all 0.6s;
    width: 100%;
    height: 100%;
  }
  img:hover {
    transform: scale(1.4);
  }
  .p1 {
    position: absolute;
    top: 165px;
    left: 960px;
    height: 235px;
    width: 350px;
    overflow: hidden;
  }
  .p2 {
    position: absolute;
    top: 432px;
    left: 960px;
    height: 235px;
    width: 350px;
    overflow: hidden;
  }
  .p3 {
    position: absolute;
    top: 165px;
    left: 1340px;
    height: 235px;
    width: 350px;
    overflow: hidden;
  }
  .p4 {
    position: absolute;
    top: 432px;
    left: 1340px;
    height: 235px;
    width: 350px;
    overflow: hidden;
  }
}
.el-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .icon {
    position: relative;
    display: flex;
    justify-content: center;
    width: 1200px;
    height: 200px;
    img {
      float: left;
      margin: auto 60px;
    }
    h1 {
      position: absolute;
      top: 150px;
    }
    .icons {
      display: flex;
      justify-content: center;
    }
  }
}
.footcontent {
  height: 100px;
  text-align: center;
  font-size: 12px;
  color: #b3b3b3;
  margin-top: 5em;
  padding-top: 30px;
  border-top: 1px solid #000;
}
.drawer {
  height: 50%;
  margin-top: 10%;
  .drawer-title {
    float: left;
    margin-left: 42px;
    margin-bottom: 10px;
  }
  .drawer-footer {
    width: 100%;
    float: left;
    line-height: 150px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue